import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store =new Vuex.Store({
    state:{
        token:"",
        user:"",
        userid:"",
        lastime:"",
        title:'',
        imglist:['https://www.baidu.com/img/baidu_jgylogo3.gif','https://www.baidu.com/img/baidu_jgylogo3.gif','https://www.baidu.com/img/baidu_jgylogo3.gif']
    },
    getters:{
    
    },
    mutations:{
        set_title(state,title){
            state.title=title
        },
        set_token(state, token) {
            state.token = token
            localStorage.token = token
        },
        set_user(state,user){
            state.user = user
            localStorage.user =user
        },
        set_userid(state,code){
            state.userid=code
            localStorage.userid = code
        },
        set_lastime(state,value){
            state.lastime=value
        },
        del_token(state) {
            state.token = ''
            localStorage.removeItem('token')
            state.user = ''
            localStorage.removeItem('user')
            state.userid = ''
            localStorage.removeItem('userid') 
        }
    },
    actions:{

    }
})


// WEBPACK FOOTER //
// ./src/store/store.js